import React from "react";
import { PrimaryButton } from "luna-react";
import { Card } from "luna-react/components/card";
import { Link } from "redux-little-router";

export default (props) => {
  const { section = {} } = props;
  const { link, text, heading, cta, className = "" } = section;
  return (
    <Card className="center-text m0 p0">
      <div className={`section_image ${className}`} />
      <h6 className="mt1">{heading || text}</h6>
      <Link className="mb1" href={link}>
        <PrimaryButton>{cta}</PrimaryButton>
      </Link>
    </Card>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/SectionCard.js